import React, { useState, useEffect } from "react";
import SalesChart from "./SalesChart/SalesChart";
import BookedOrdersChart from "./BookedOrdersChart/BookedOrdersChart";
import BookedOrdersBarChart from "./BookedOrdersBarChart/BookedOrdersBarChart";
import IndividualTargetsChart from "./IndividualTargetsChart/IndividualTargetsChart";
import CompanyTargetsChart from "./CompanyTargetsChart/CompanyTargetsChart";
import "./Diagrams.css";

const Diagrams = () => {
  const [bookedOrdersChartWidth, setBookedOrdersChartWidth] = useState(560);
  const [dataBarChartWidth, setDataBarChartWidth] = useState(560);

  useEffect(() => {
    const bookedOrdersChartContainer = document.getElementById(
      "bookedOrdersLineChartContainer"
    );
    const dataBarChartContainer = document.getElementById(
      "individualChartContainer"
    );

    const handleResize = () => {
      setBookedOrdersChartWidth(bookedOrdersChartContainer.offsetWidth);
      setDataBarChartWidth(dataBarChartContainer.offsetWidth);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="card chart-section">
      <div className="card-body py-2 chart-card-body">
        <div className="row g-2 h-100">
          <div className="col-12 col-md-6" id="bookedOrdersBarChartContainer">
            <BookedOrdersBarChart
              width={dataBarChartWidth - 50}
              height={320}
              isAutomated={false}
              fontSize={12}
              margin={20}
            />
          </div>
          <div className="col-12 col-md-6" id="bookedOrdersLineChartContainer">
            <BookedOrdersChart
              width={bookedOrdersChartWidth - 50}
              height={330}
              isAutomated={false}
              fontSize={12}
              margin={20}
            />
          </div>
          <div className="col-12 col-md-6" id="individualChartContainer">
            <CompanyTargetsChart
              width={dataBarChartWidth - 50}
              height={315}
              isAutomated={false}
              fontSize={12}
              margin={20}
            />
          </div>
          <div className="col-12 col-md-6" id="companyChartContainer">
            <IndividualTargetsChart
              width={bookedOrdersChartWidth - 50}
              height={315}
              isAutomated={false}
              fontSize={12}
              margin={20}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Diagrams;
